var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',_vm._b({attrs:{"type":"time","pattern":"[0-9]{2}:[0-9]{2}","placeholder":"13:45"},model:{value:(_vm.timeCode),callback:function ($$v) {_vm.timeCode=$$v},expression:"timeCode"}},'b-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }